import axios from "axios";
import { getContainersList } from "../../services/container";
import { getSettingsData } from "../../services/settings";

const getMonitoringListRequestParams = () => ({
  page: null,
  limit: null,
  fieldSort: "filling_level",
  orderSort: "-1",
  keywordFilter: JSON.stringify([]),
  arrayFilterFillingLevel: JSON.stringify([0, 100]),
  typeFillingFilter: "all",
  stopTime: "",
});

const filterContainersForMonitoringList = (containers, alertNumberOfDays) => {
  const sortedData = [...containers].sort((a, b) =>
    a.addressName.localeCompare(b.addressName),
  );

  return sortedData.reduce((acc, item) => {
    const deltaAlert = Math.floor(
      (new Date().getTime() - new Date(item._time).getTime()) / 86400000,
    );

    if (deltaAlert <= alertNumberOfDays && !item.characterization) {
      const address = item.addressName;
      if (!acc[address]) {
        acc[address] = [];
      }
      acc[address].push(item);
    }

    return acc;
  }, {});
};

const getCriticalFillingCountFromDelivery = (arrayFillingDelivery) => {
  const criticalEntry = arrayFillingDelivery?.find(
    (entry) => entry.type === "critical",
  );

  return criticalEntry?.value ?? 0;
};

export const fetchMonitoringGroupedContainers = async () => {
  const [responseData, responseSettings] = await axios.all([
    getContainersList(getMonitoringListRequestParams()),
    getSettingsData(),
  ]);

  if (responseData.status !== 200 && responseSettings.status !== 200) {
    return { groupedContainers: {}, settings: null };
  }

  const alertNumberOfDays =
    responseSettings.data?.settings?.alertNumberOfDays ?? 30;
  const groupedContainers = filterContainersForMonitoringList(
    responseData.data?.data ?? [],
    alertNumberOfDays,
  );

  return {
    groupedContainers,
    settings: responseSettings.data?.settings ?? null,
    criticalFillingCount: getCriticalFillingCountFromDelivery(
      responseData.data?.arrayFillingDelivery,
    ),
  };
};
